const GLOBAL_CUSTOM_EVENTS = new Set([
  "onboardingv2_signup_completed",
  "onboardingv2_signup_verification_completed",
  "onboardingv2_step_one_complete",
  "onboardingv2_step_two_complete",
  "onboardingv2_employment_step_complete",
  "onboardingv2_financial_profile_step_complete",
  "onboardingv2_step_three_complete",
  "onboardingv2_kyc_complete",
  "onfido_started",
  "onfido_finished",
  "onfido_abandoned",
  "onfido_workflow_started",
  "onfido_workflow_finished",
  "algodash_entity_onboarding_started",
  "algodash_entity_onboarding_completed",
  "algodash_entity_onboarding_page_completed",
  "algodash_options_opt_in_started",
  "algodash_options_opt_in_completed",
  "algodash_options_opt_in_page_completed",
  "deposit_submitted_v2",
  "plaid_event",
  "plaid_finished",
  "plaid_oauth_session_saved",
  "plaid_oauth_session_save_failed",
  "plaid_oauth_resume_detected",
  "plaid_oauth_resume_auto_opened",
  "plaid_oauth_resume_unavailable",
  "plaid_oauth_resume_token_expired",
  "plaid_link_validation_failed",
  "plaid_auth_status_failed",
  "plaid_relationship_failed",
  "plaid_duplicate_success_suppressed",
  "algodash_enrolled_high_yield_cash",
  "algodash_enrolled_fpsl",
  "acats_submitted",
  "market_data_enrolled",
  "crypto_transfers_crypto_agreement_finished",
  "md_cta_clicked",
  "md_utp_clicked",
  "md_opra_clicked",
  "confirm_order_on_asset_page_clicked",
]);

export const shouldTrackCustomEventInGlobal = (eventName: string): boolean =>
  GLOBAL_CUSTOM_EVENTS.has(eventName);
